/* eslint-disable
    @typescript-eslint/no-explicit-any,
    react/prefer-stateless-function
*/
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import classNames from 'classnames';
import React from 'react';

interface CrumbLinkProps {
  className: string;
  isLoading?: boolean;
  onClick?: (...args: Array<any>) => any;
}

export class CrumbLink extends React.Component<CrumbLinkProps> {
  static defaultProps = {
    className: 'genericBreadcrumbs-link',
  };

  render(): JSX.Element {
    if (this.props.isLoading) {
      return <span className={this.props.className}>...</span>;
    } else {
      return (
        <a className={this.props.className} onClick={this.props.onClick}>
          {this.props.children}
        </a>
      );
    }
  }
}

interface BreadcrumbsProps {
  className: string;
}

// TODO(T7355): Generalize component to support existing Breadcrumbs (i.e. nav) and change classNames to
// '.breadcrumbs'.
class Breadcrumbs extends React.Component<BreadcrumbsProps> {
  static defaultProps = {
    className: 'genericBreadcrumbs',
  };

  _renderCrumbs = (crumbs: Array<React.ReactNode>): React.ReactNode => {
    if (crumbs.length === 0) {
      return [];
    } else if (crumbs.length === 1) {
      return crumbs.concat(' / ');
    } else {
      // crumbs.length >= 2
      return [crumbs[0], ' / ', <span key="sub-crumbs">{this._renderCrumbs(crumbs.slice(1))}</span>];
    }
  };

  render(): JSX.Element {
    const children = React.Children.toArray(this.props.children);
    return (
      <div className={classNames(this.props.className, 'legacy-font-proxima-13')}>
        {this._renderCrumbs(children)}
      </div>
    );
  }
}

export default Breadcrumbs;
